var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8867 24.8439C44.0207 23.6242 42.721 22.7819 41.2541 22.4898L32.029 20.6448V10.3948C32.029 9.22977 31.5662 8.1124 30.7423 7.28859C29.9185 6.46477 28.8012 6.00195 27.6361 6.00195C26.4711 6.00195 25.3537 6.46477 24.5299 7.28859C23.7061 8.1124 23.2432 9.22977 23.2432 10.3948V25.0377V30.0391C21.9106 30.677 16.5031 23.5391 13.0033 27.0391C10.4295 29.613 13.5033 34.5391 14.5034 36.0391C15.5035 37.5391 20.003 43.0391 20.5729 43.5694C21.1429 44.0997 21.6317 44.074 22.2182 44.0734H41.1955C41.906 44.0804 42.5951 43.8288 43.1336 43.3653C43.6725 42.902 44.0245 42.2585 44.1241 41.5548L45.9105 29.0498C46.1187 27.5685 45.7524 26.0637 44.8867 24.8439Z",
    stroke: "#24272C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79714 15.646L5.00636 23.4495M5.00636 23.4495L12.8098 21.2403M5.00636 23.4495L16.5446 2.79827M16.5446 2.79827L8.74106 5.00748M16.5446 2.79827L18.7538 10.6018",
    stroke: "#24272C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomIn);
export default __webpack_public_path__ + "static/media/iconZoomIn.870731c9cd76ea1251f99a30840f445a.svg";
export { ForwardRef as ReactComponent };